<template>
  <div class="goal-selection">
    <section-title has-line title="Metas Académicas Relacionada(s)" />
    <div class="d-flex flex-row justify-content-between align-items-start">
      <div class="col-12 pr-3 border-right">
        <validation-provider
          ref="goalValidator"
          v-slot="{ errors }"
          name="customDropDownGoal"
        >
          <CustomMultiSelect
            v-model="selectedGoals"
            :error-message="errors[0]"
            label="Seleccionar Meta:"
            :options="availableGoalOptions"
          />
        </validation-provider>
        <div class="row mt-3">
          <div class="col-12">
            <Error
              is-alert-mode
              message="Puede seleccionar una(1) o más metas. Selección múltiple."
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomMultiSelect from '@/components/common/CustomMultiSelect.vue';
import Error from '@/components/common/Error';

export default {
  name: 'GoalSelection',
  components: {
    SectionTitle,
    CustomMultiSelect,
    Error,
  },
  props: {
    goalOptions: {
      type: Array,
      default: () => [],
    },
    selectedGoals: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    availableGoalOptions() {
      return this.goalOptions.map((x) => ({
        ...x,
        nameDetail: `[${x.areaName}]`,
      }));
    },
  },
  watch: {
    selectedGoals: {
      handler(newVal) {
        this.$emit('save-goal-selection', newVal);
      },
      deep: true,
    },
  },
  methods: {
    onAddHandler() {
      if (this.model.goal) {
        this.selectedGoals.push(this.model.goal);
        this.model.goal = null;
        this.$refs.goalValidator.setErrors([]);
        this.$emit('save-goal-selection', this.selectedGoals);
      } else {
        this.$refs.goalValidator.setErrors(['Favor seleccionar una meta.']);
      }
    },
    onDeleteItemHandler(index) {
      this.selectedGoals.splice(index, 1);
      this.$emit('save-goal-selection', this.selectedGoals);
    },
  },
};
</script>

<style scoped lang="scss">
.reason-item {
  border-radius: 50px;
  border: 1px solid gainsboro;
  width: fit-content;
  font-size: 90%;
}
::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}
</style>
